import { Component } from '@angular/core';
import { MedrecordIcon } from '../../../base/medrecord-icon';

@Component({
  selector: 'medrecord-svg-insta',
  templateUrl: './insta.component.svg',
})
export class InstaComponent extends MedrecordIcon {
  viewHeight = 16;
  viewWidth = 16;
}
